// quickopen — pure ranking for the "Search Everywhere" palette. No DOM imports,
// so it's unit-testable. Given a flat object index (table/view/routine entries),
// a query, and the current database, return the best matches ranked.
//
// Entry shape: { database, name, kind: 'table'|'view'|'function'|'procedure' }.

// subseq: are all chars of q present in text, in order? (fuzzy fallback)
function subseq(q, text) {
  let i = 0;
  for (let j = 0; j < text.length && i < q.length; j++) {
    if (text[j] === q[i]) i++;
  }
  return i === q.length;
}

// scoreEntry: higher is better; -1 means "no match". Tiers: exact name > name
// prefix > name substring > db.name substring > fuzzy subsequence. Current-DB
// objects and tables/views get a small bump so ties resolve sensibly.
export function scoreEntry(q, entry, currentDb) {
  const name = entry.name.toLowerCase();
  const full = `${entry.database}.${entry.name}`.toLowerCase();
  let s;
  if (!q) {
    s = 10; // no query → list everything (current-db + tables float up via the bumps)
  } else if (name === q) s = 100;
  else if (name.startsWith(q)) s = 80;
  else if (name.includes(q)) s = 60;
  else if (full.includes(q)) s = 40;
  else if (subseq(q, full)) s = 20;
  else return -1;
  if (entry.database === currentDb) s += 6;
  if (entry.kind === 'table' || entry.kind === 'view') s += 1;
  return s;
}

// rankCommands ranks command-palette entries by their label (and group as a
// weaker signal). Each command is { label, group?, ... }; the caller pre-filters
// to the commands currently available. Same tiering as scoreEntry.
export function rankCommands(commands, query, limit = 50) {
  const q = (query || '').trim().toLowerCase();
  const scored = [];
  for (const c of commands || []) {
    const label = (c.label || '').toLowerCase();
    const group = (c.group || '').toLowerCase();
    let s;
    if (!q) s = 10;
    else if (label === q) s = 100;
    else if (label.startsWith(q)) s = 80;
    else if (label.includes(q)) s = 60;
    else if (`${group} ${label}`.includes(q)) s = 40;
    else if (subseq(q, label)) s = 25;
    else continue;
    scored.push({ c, s });
  }
  scored.sort((a, b) => b.s - a.s || a.c.label.localeCompare(b.c.label));
  return scored.slice(0, limit).map((x) => x.c);
}

export function rankObjects(index, query, currentDb, limit = 60) {
  const q = (query || '').trim().toLowerCase();
  const scored = [];
  for (const e of index || []) {
    const s = scoreEntry(q, e, currentDb);
    if (s >= 0) scored.push({ e, s });
  }
  scored.sort((a, b) =>
    b.s - a.s ||
    a.e.name.localeCompare(b.e.name) ||
    a.e.database.localeCompare(b.e.database));
  return scored.slice(0, limit).map((x) => x.e);
}
